// extracted by mini-css-extract-plugin
export default {"bannerWrapper":"OTCmrm3f4Fr5K6uWskVS"};